import * as React from "react";
import { Dropdown } from "../../utils/dropdown";
import DeviceContext from "../../service/indentifyDevice";
import { Idevice } from "../../types/device";
import { config } from "../../../config/domain";

export interface IGuest {
	contactNo?: string;
}
const device: Idevice = DeviceContext();

export function SupportCenter(props: IGuest) {
	//support center dropdown list items with dynamic  part
	const supportCenterDDList = [
		{
			link: config.rootUrl + "user-guide/web",
			icon: "edel-icon-bulb",
			text: "Get Started",
			id: 5,
			mobText: "",
			hideMob: true
		},
		{
			link: config.rootUrl + "faqs/",
			icon: "edel-icon-faqs",
			text: "Visit FAQs",
			mobText: "FAQs",
			id: 4
		},
		{
			link: "",
			icon: "edel-icon-call",
			text: props.contactNo,
			mobText: "Call us",
			subText: " (8:30 AM - 5:30 PM)",
			id: 1
		},
		{
			link: "mailto:helpdesk@nuvama.com",
			icon: "edel-icon-email-us",
			text: "helpdesk@nuvama.com",
			mobText: "Email us",
			id: 2
		},
		{
			link: config.rootUrl + "location",
			icon: "edel-icon-locate-us",
			text: "Locate Us",
			id: 3,
			mobText: "Locate us"
		},
		{
			link: config.rootUrl + "forgot-password",
			icon: "edel-icon-login-help",
			id: 6,
			mobText: "Locate us",
			hideDesk: true
		}
	];
	const sCDDCont = {
		headerTitle: <div className="headerSubLinks">Support Center</div>,
		list: (
			<>
				<ul className="dd-list">
					{supportCenterDDList.map(
						(item: any) =>
							!item.hideDesk && (
								<li className=" dd-list-item" key={item.id}>
									{item.link && (
										<a className="listLink" href={item.link}>
											{item.icon && <i className={"listIcon " + item.icon}></i>}
											{item.text}
										</a>
									)}
									{!item.link && (
										<label className="listText">
											{item.icon && <i className={"listIcon " + item.icon}></i>}
											<span>{item.text}</span>
										</label>
									)}
									{item.subText && <span className="subText">{item.subText}</span>}
								</li>
							)
					)}
				</ul>
			</>
		),
		mobList: (
			<>
				{/* <ul className="mobSupportCenter">
					{supportCenterDDList
						.sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
						.map(
							(lItem: any) =>
								!lItem.hideMob && (
									<li className="ib vMid" key={lItem.id}>
										<a href={lItem.link} className="ed_link ib vMid">
											<p>
												<i className={lItem.icon}></i>
											</p>
											{lItem.mobText}
										</a>
									</li>
								)
						)}
				</ul> */}
			</>
		)
	};
	let retCont = null;
	if (device.isDesktop) {
		retCont = <Dropdown headerTitle={sCDDCont.headerTitle} arrow={false} class="supportCenter" selectItem={false} listCont={sCDDCont.list} />;
	} else {
		retCont = sCDDCont.mobList;
	}
	return retCont;
}
export function LoginToNav(props: IGuest) {
	//Logindropdown list items with dynamic  part

	const loginDDList = [
		{
			link: config.rootUrl + "?ottype=place-order",
			icon: "",
			text: "Buy/Sell",
			subText: "Quickly Buy Stocks, Mutual Funds, SIPs, Currency etc.",
			id: 2
		},
		{
			link: config.rootUrl + "?ottype=fund-transfer",
			icon: "",
			text: "Transfer Funds",
			subText: "Transfer funds between your bank account and trading account with ease.",
			id: 3
		},
		{
			link: config.rootUrl + "reports",
			icon: "",
			text: "My reports",
			subText: "View your portfolio overview and other reports here.",
			id: 4
		}
	];

	const loginDDCont = {
		header: (
			<label className="login loginBtn vMid" id="login">
				<span className="text">Login</span>
			</label>
		),
		list: (
			<>
				<div className="listHeader pl-15">LOGIN TO</div>
				<ul className="dd-list by3">
					{loginDDList.map((item: any) => (
						<li className="dd-list-item pd-rl-15 vTop" key={item.id}>
							<a href={item.link} className="logInLink ib">
								<label className="linkHead  mb-13 dBlock ed_link">{item.text}</label>
								<p className="linkSubText dBlock">{item.subText}</p>
							</a>
						</li>
					))}
				</ul>

				<div className="loginHelp">
					<div className="by2">
						<div className="vTop">
							<a className="logInLink dBlock" href={config.rootUrl + "active-trader"}>
								<label className="listHeader dBlock goto">go to</label>
								<div className="d-flex">
									<div><i className="icon-b icon-20 icon-loung"></i></div>
									<div className="d-flex ml-5"><label className="linkHead ed_link ib">Active Trader ?</label></div>
								</div>
								<p className="linkSubText">Active traders will find themselves at home</p>
							</a>
						</div>
						<div className="vTop second_half_goto">
							<label className="listHeader pl-15">Trouble Logging In?</label>
							<a href={config.rootUrl + "forgot-password"} className="logInLink dBlock">
								<i className="icon-b icon-20 icon-keyh vMid"></i>
								<label className="linkHead linkHeadChange ml-3 ed_link ib vMid">Login Help</label>
							</a>
							<a href={config.rootUrl + "faqs/"} className="logInLink dBlock">
								<i className="icon-b icon-20 icon-quest vMid"></i>
								<label className="linkHead linkHeadChange  ml-3 ed_link ib vMid">See FAQs</label>
							</a>
						</div>
					</div>
				</div>
			</>
		)
	};
	return (
		<Dropdown headerTitle={loginDDCont.header} arrow={false} class="loginDD" selectItem={false} listCont={loginDDCont.list} listHeader="LOGIN" />
	);
}
export default SupportCenter;
